module.exports = __webpack_public_path__ + "img/web-formularios-04.86c4764d.svg";